const storageKey = "deliverit.guestOrderDraft";
const maxAgeMs = 24 * 60 * 60 * 1000;

const hasCoordinate = (location) =>
  Boolean(location)
  && Boolean(location.coordinate)
  && location.coordinate.latitude !== ""
  && location.coordinate.longitude !== ""
  && location.coordinate.latitude !== null
  && location.coordinate.longitude !== null;

const upcoming = (value) => {
  if (!value) return "";

  const date = new Date(value);
  return isNaN(date.getTime()) || date.getTime() < Date.now() ? "" : date;
}

const normaliseDropOff = (dropOff) => ({
  dropOffLocation: dropOff.dropOffLocation,
  recipientName: dropOff.recipientName || "",
  recipientPhone: dropOff.recipientPhone || "",
  deliverDateTime: upcoming(dropOff.deliverDateTime),
  doorToDoor: dropOff.doorToDoor || false,
  isCodEnabled: dropOff.isCodEnabled || false,
  codAmount: dropOff.codAmount || 0,
});

export const clearGuestDraft = () => {
  try {
    localStorage.removeItem(storageKey);
  } catch (e) { }
}

export const loadGuestDraft = () => {
  try {
    const stored = localStorage.getItem(storageKey);
    if (!stored) return null;

    const parsed = JSON.parse(stored);
    if (!parsed || !hasCoordinate(parsed.pickUpLocation) || Date.now() - (parsed.savedAt || 0) > maxAgeMs) {
      clearGuestDraft();
      return null;
    }

    return {
      deliveryMethod: parsed.deliveryMethod || "MOTOR",
      halal: parsed.halal || false,
      pickUpPersonName: parsed.pickUpPersonName || "",
      pickUpContactNumber: parsed.pickUpContactNumber || "",
      pickUpDateTime: upcoming(parsed.pickUpDateTime),
      pickUpLocation: parsed.pickUpLocation,
      dropOffs: (parsed.dropOffs || [])
        .filter(dropOff => hasCoordinate(dropOff && dropOff.dropOffLocation))
        .map(normaliseDropOff)
    };
  } catch (e) {
    clearGuestDraft();
    return null;
  }
}

export const saveGuestDraft = (pickUpForm, dropOffs) => {
  if (!hasCoordinate(pickUpForm.pickUpLocation)) return;

  try {
    localStorage.setItem(storageKey, JSON.stringify({
      deliveryMethod: pickUpForm.deliveryMethod,
      halal: pickUpForm.halal,
      pickUpPersonName: pickUpForm.pickUpPersonName,
      pickUpContactNumber: pickUpForm.pickUpContactNumber,
      pickUpDateTime: pickUpForm.pickUpDateTime,
      pickUpLocation: pickUpForm.pickUpLocation,
      dropOffs: (dropOffs || [])
        .filter(dropOff => hasCoordinate(dropOff && dropOff.dropOffLocation))
        .map(normaliseDropOff),
      savedAt: Date.now()
    }));
  } catch (e) { }
}

export const hasPendingGuestDropOffs = () => {
  const draft = loadGuestDraft();
  return Boolean(draft) && draft.dropOffs.length > 0;
}

export const takeNextGuestDropOff = () => {
  const draft = loadGuestDraft();
  if (!draft || draft.dropOffs.length === 0) return null;

  const [next, ...rest] = draft.dropOffs;
  if (rest.length === 0) {
    clearGuestDraft();
  } else {
    saveGuestDraft(draft, rest);
  }

  return next;
}
